// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var SftpSettings$ReactHooksTemplate = require("./SftpSettings.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");

function SftpForm(props) {
  var __isEdit = props.isEdit;
  var onCancel = props.onCancel;
  var onChange = props.onChange;
  var sftpConf = props.sftpConf;
  var isEdit = __isEdit !== undefined ? __isEdit : false;
  var handleNameChange = function ($$event) {
    Curry._1(onChange, SftpSettings$ReactHooksTemplate.setName(sftpConf, Utils$ReactHooksTemplate.formTargetValue($$event)));
  };
  var handleHostChange = function ($$event) {
    Curry._1(onChange, SftpSettings$ReactHooksTemplate.setHost(sftpConf, Utils$ReactHooksTemplate.formTargetValue($$event)));
  };
  var handlePortChange = function ($$event) {
    Curry._1(onChange, SftpSettings$ReactHooksTemplate.setPort(sftpConf, Utils$ReactHooksTemplate.formTargetValue($$event)));
  };
  var handleUsernameChange = function ($$event) {
    Curry._1(onChange, SftpSettings$ReactHooksTemplate.setUsername(sftpConf, Utils$ReactHooksTemplate.formTargetValue($$event)));
  };
  var handlePasswordChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(onChange, SftpSettings$ReactHooksTemplate.setPassword(sftpConf, value));
  };
  var handleActiveToggle = function (param) {
    Curry._1(onChange, SftpSettings$ReactHooksTemplate.setIsActive(sftpConf, !SftpSettings$ReactHooksTemplate.isActive(sftpConf)));
  };
  var match = React.useState(function (param) {
        return false;
      });
  var setShowPassword = match[1];
  var showPassword = match[0];
  var p = SftpSettings$ReactHooksTemplate.password(sftpConf);
  var passwordValue = p !== undefined ? p : "";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "SFTP Configurations",
                      className: "px-5 py-6 border-b border-gray-300 text-darkcharcoal font-bold text-xl"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: isEdit ? "Edit SFTP Configuration" : "Create SFTP Configuration",
                              className: "text-lg font-semibold text-darkcharcoal mb-4"
                            }),
                        JsxRuntime.jsxs("form", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Configuration Name",
                                              className: "block text-sm font-medium text-aurometalsaurus w-48 mb-0"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                    label: "",
                                                    value: SftpSettings$ReactHooksTemplate.name(sftpConf),
                                                    handleChange: handleNameChange,
                                                    placeholder: "Enter configuration name",
                                                    textInputClassName: "h-10 p-3 border border-gray-400 rounded-md w-full"
                                                  }),
                                              className: "flex-1"
                                            })
                                      ],
                                      className: "flex items-center w-full gap-x-4"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Host",
                                              className: "block text-sm font-medium text-aurometalsaurus w-48 mb-0"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                    label: "",
                                                    value: SftpSettings$ReactHooksTemplate.host(sftpConf),
                                                    handleChange: handleHostChange,
                                                    placeholder: "Type SFTP Host",
                                                    textInputClassName: "h-10 p-3 border border-gray-400 rounded-md w-full"
                                                  }),
                                              className: "flex-1"
                                            })
                                      ],
                                      className: "flex items-center w-full gap-x-4"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Port",
                                              className: "block text-sm font-medium text-aurometalsaurus w-48 mb-0"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                    label: "",
                                                    value: SftpSettings$ReactHooksTemplate.port(sftpConf),
                                                    handleChange: handlePortChange,
                                                    placeholder: "Type SFTP Port (default 22)",
                                                    textInputClassName: "h-10 p-3 border border-gray-400 rounded-md w-full"
                                                  }),
                                              className: "flex-1"
                                            })
                                      ],
                                      className: "flex items-center w-full gap-x-4"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Username",
                                              className: "block text-sm font-medium text-aurometalsaurus w-48 mb-0"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                    label: "",
                                                    value: SftpSettings$ReactHooksTemplate.username(sftpConf),
                                                    handleChange: handleUsernameChange,
                                                    placeholder: "Type SFTP Username",
                                                    textInputClassName: "h-10 p-3 border border-gray-400 rounded-md w-full"
                                                  }),
                                              className: "flex-1"
                                            })
                                      ],
                                      className: "flex items-center w-full gap-x-4"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Password",
                                              className: "block text-sm font-medium text-aurometalsaurus w-48 mb-0"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("input", {
                                                      className: "h-10 p-3 border border-gray-400 rounded-md w-3/5",
                                                      placeholder: "Password",
                                                      type: showPassword ? "text" : "password",
                                                      value: passwordValue,
                                                      onChange: handlePasswordChange
                                                    }),
                                                JsxRuntime.jsx("button", {
                                                      children: showPassword ? JsxRuntime.jsx("img", {
                                                              className: "h-5 w-5",
                                                              src: Image$ReactHooksTemplate.previewEye
                                                            }) : JsxRuntime.jsx("img", {
                                                              className: "h-5 w-5",
                                                              src: Image$ReactHooksTemplate.closedEye
                                                            }),
                                                      "aria-label": showPassword ? "Hide password" : "Show password",
                                                      className: "focus:outline-none",
                                                      tabIndex: 0,
                                                      type: "button",
                                                      onClick: (function (param) {
                                                          Curry._1(setShowPassword, (function (show) {
                                                                  return !show;
                                                                }));
                                                        })
                                                    })
                                              ],
                                              className: "flex-1 flex justify-end gap-2"
                                            })
                                      ],
                                      className: "flex items-center w-full gap-x-4"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Active",
                                              className: "block text-sm font-medium text-aurometalsaurus w-48 mb-0"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                    checked: SftpSettings$ReactHooksTemplate.isActive(sftpConf),
                                                    handleChange: handleActiveToggle,
                                                    labelClassName: "flex items-center"
                                                  }),
                                              className: "flex-1"
                                            })
                                      ],
                                      className: "flex items-center w-full gap-x-4"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("button", {
                                              children: "Cancel",
                                              className: "bg-white py-6-px px-20-px border border-gray-300 rounded-md shadow-sm text-sm font-medium text-aurometalsaurus hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600",
                                              type: "button",
                                              onClick: (function (param) {
                                                  Curry._1(onCancel, undefined);
                                                })
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: isEdit ? "Update SFTP Configuration" : "Create SFTP Configuration",
                                              className: "bg-blue-600 py-6-px px-20-px border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600",
                                              type: "submit"
                                            })
                                      ],
                                      className: "flex justify-end space-x-3 pt-6 mt-6"
                                    })
                              ],
                              className: "p-0 space-y-4",
                              onSubmit: props.onSubmit
                            })
                      ],
                      className: "p-8"
                    })
              ]
            });
}

var make = SftpForm;

exports.make = make;
/* react Not a pure module */
